import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M16.359 19.75H7.64a1.455 1.455 0 01-1.453-1.453v-1.938a.484.484 0 11.968 0v1.938c0 .267.218.484.484.484h8.719a.485.485 0 00.484-.484v-1.938a.484.484 0 01.968 0v1.938c0 .801-.652 1.453-1.453 1.453z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 15.909a.485.485 0 01-.343-.826l3.425-3.424a.485.485 0 01.685.685l-3.425 3.424a.482.482 0 01-.342.141z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 15.909a.486.486 0 01-.343-.141l-3.425-3.426a.485.485 0 01.685-.685l3.425 3.425a.485.485 0 01-.342.827z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 15.909a.484.484 0 01-.484-.484V4.735a.484.484 0 11.968 0v10.69a.484.484 0 01-.484.484z"
})), 'Download');